export default "__VITE_ASSET__1dc58b4d__"